module.exports = __webpack_public_path__ + "media/images/screen-break-4dfc743f6f8fd5f548c7d96b34dea2fc.svg";